import { useMutation, useQuery } from 'react-query'
import { Entity } from 'utils/hooks'
import { useBakersAttributesService } from 'services/bakersAttributesService'
import { useBakersProductsService } from 'services/bakersProductsService'
import { TBakersProduct } from 'types/models/BakersProducts'
import { ProductsModuleAdapter } from '../types/shared.types'

export const bakersProductsAdapter: ProductsModuleAdapter = {
  moduleKey: 'bakers',
  headerTitle: 'Baker Products',
  addButtonText: 'Add Product',
  tableKey: 'bakersProducts',
  labels: {
    nameColumn: 'Product Name',
    deleteConfirmTitle: 'Are you sure you want to remove this Product?',
    loadingText: 'Loading...',
  },
  toasts: {
    created: 'Product created',
    updated: 'Product updated',
    deleted: 'Product deleted successfully',
    deleteFailed: 'Product cannot be deleted',
    updateFailed: 'An error occurred while updating product',
  },
  invalidatQueryName: 'bakers_products_list',
  // TODO change to correct permissions
  permissionEntity: Entity.PRODUCT,

  useDefaultAttributes() {
    const { getBakersAttributes } = useBakersAttributesService()
    const q = useQuery({
      queryKey: ['bakers_product_attributes'],
      queryFn: () => getBakersAttributes(),
    })
    return { data: q.data }
  },

  useCategories() {
    const { getBakersCategoriesWithAttributes } = useBakersAttributesService()
    const q = useQuery({
      queryKey: ['bakers_categories_with_attributes'],
      queryFn: () => getBakersCategoriesWithAttributes(),
    })
    return { data: q.data }
  },

  computeValidationRules(attrs) {
    return (attrs ?? []).reduce(
      (acc, a: any) => {
        acc[a.name] = {
          min: a?.min_value || 0,
          max: a?.max_value || 0,
          hardMax: a?.hard_max || 0,
          hardMin: a?.hard_min || 0,
          warnAbove: a?.warn_above || 0,
          warnBelow: a?.warn_below || 0,
        }
        return acc
      },
      {} as Record<string, any>
    )
  },

  useProducts({ currentPage, itemsPerPage }) {
    const { getBakersProducts } = useBakersProductsService()
    const q = useQuery({
      queryKey: ['bakers_products_list', currentPage, itemsPerPage, 'bakers'],
      queryFn: () => getBakersProducts({ currentPage, itemsPerPage }),
      retry: false,
    })
    return { data: q.data, isLoading: q.isLoading }
  },

  useCreate() {
    const { createBakersProduct } = useBakersProductsService()
    const m = useMutation(createBakersProduct)
    return (p: TBakersProduct) => m.mutateAsync(p)
  },

  useUpdate() {
    const { updateBakersProduct } = useBakersProductsService()
    const m = useMutation(updateBakersProduct)
    return (p: TBakersProduct) => m.mutateAsync(p)
  },

  useDelete() {
    const { deleteBakersProduct } = useBakersProductsService()
    const m = useMutation(deleteBakersProduct)
    return (id: number) => m.mutateAsync(id)
  },
}
